module.exports = __webpack_public_path__ + "static/media/back-arrow-header.0a2a5476.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/back-arrow-header.svg
// module id = 291
// module chunks = 0